import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from '../services/auth';

export const trainerGuard: CanActivateFn = () => {
  const auth   = inject(Auth);
  const router = inject(Router);

  if (!auth.isLoggedIn() || auth.getRole() !== 'TRAINER') {
    router.navigate(['/auth/trainer-login']);
    return false;
  }

  return true;
};
